import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import './stylus/main.styl';

import "./css/bootstrap.min.css";
import "./css/style.css";

//External components
import VueTimepicker from "vue2-timepicker";
// import * as VueGoogleMaps from "vue2-google-maps";
import BlockUI from "vue-blockui";
import VueCookies from "vue-cookies";
import axios from "axios";
import vueHeadful from "vue-headful";
import VueGoogleCharts from "vue-google-charts";
import VueClipboard from "vue-clipboard2";

//Import custom components
import DialogCompanyRates from "./components/admin/dialogs/DialogCompanyRates";
import DialogCustomerRank from "./components/admin/dialogs/DialogCustomerRank";
import DialogManageQuotation from "./components/admin/dialogs/DialogManageQuotation";
import DialogManageInvoice from "./components/admin/dialogs/DialogManageInvoice";
import DialogEmailWidget from "./components/admin/dialogs/DialogEmailWidget.vue";
import DialogTonnageSelection from "./components/admin/dialogs/DialogTonnageSelection.vue"; 
import DialogTransportTonnages from "./components/admin/dialogs/DialogTransportTonnages.vue";

import DialogCustomerList from "./components/admin/dialogs/DialogCustomerList";
import DialogNewQuotation from "./components/user/DialogNewQuotation";

import DialogCopyMonthlyRates from "./components/admin/dialogs/DialogCopyMonthlyRates";

// Customer accessible dialogs
import DialogCompany from "./components/user/DialogCompany";
import DialogUserAccount from "./components/user/DialogUserAccount";
import DialogCompanyContactList from "./components/user/DialogCompanyContactList";
import DialogQuotationOverview from "./components/user/DialogQuotationOverview.vue";
import DialogScheduleList from "./components/user/DialogScheduleList";
import DialogshipmentInformation from "./components/user/DialogShipmentInformation.vue";
import DialogNotifyPullBack from "./components/user/DialogNotifyPullBack.vue";
import DialogMessageBox from "./components/user/DialogMessageBox.vue";
import DialogMessageNotifier from "./components/user/DialogMessageNotifier.vue";
import DialogFileCabinet from "./components/user/DialogFileCabinet.vue";

// Custom shared components
import FinancialComponentTable from "./components/shared/FinancialComponentTable.vue";
import QuotationInvoiceTable from "./components/shared/QuotationInvoiceTable.vue";
import QuotationOverview from "./components/shared/QuotationOverview.vue";
import FileDropZone from "./components/shared/FileDropZone.vue";
import QuotationFileUpload from "./components/shared/QuotationFileUpload.vue";
import ContactLayout from "./components/shared/ContactLayout.vue";
import ContactInfoLayout from "./components/shared/ContactInfoLayout.vue";
import ShipmentWorkflowView from "./components/shared/ShipmentWorkflowView.vue";
import ShipmentFilesCount from "./components/shared/ShipmentFilesCount.vue";
import PtRatesCell from "./components/shared/pt/PtRatesCell.vue";
import PtRatesCellPrice from "./components/shared/pt/PtRatesCellPrice.vue";
import PtRatesCellCost from "./components/shared/pt/PtRatesCellCost.vue";
import PtRatesCellAirPrice from "./components/shared/pt/PtRatesCellAirPrice.vue";
import PtRatesCellAirCost from "./components/shared/pt/PtRatesCellAirCost.vue";
import ActivityLog from "./components/shared/ActivityLog.vue";
import FilesCabinetZone from "./components/shared/FilesCabinetZone.vue";
import ImportClearanceMilestone from "./components/shared/milestones/ImportClearanceMilestone.vue";
import ExportClearanceMilestone from "./components/shared/milestones/ExportClearanceMilestone.vue";

import DialogFileList from "./components/user/DialogFileList";
import constant from "./const.js";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// Initialize Default Firebase Project (af-cloud-webserver)
var config = {
  apiKey: "AIzaSyC0_AEK3wEipej4KWmX-6izK8lYA81Drro",
  authDomain: "cloud-accele-freight.firebaseapp.com",
  projectId: "cloud-accele-freight"
}
firebase.initializeApp(config)

// Initialize another Firebase Project (af-cloud-notifications)
var messageCenterAppInstance = firebase.initializeApp({
    apiKey: "AIzaSyDlPHWKgHU865r4PhvzjvBemv7rFD55__I",
    authDomain: "af-cloud-notifications.firebaseapp.com",
    projectId: "af-cloud-notifications"
  },
  "message-center-app"
)

//Imported components
Vue.component("vue-timepicker", VueTimepicker)
Vue.use(BlockUI)
Vue.use(VueCookies)
Vue.use(VueGoogleCharts)
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: constant.GMAP_API_KEY
//     // libraries: 'places', // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)

//     //// If you want to set the version, you can do so:
//     // v: '3.26',
//   }

//   //// If you intend to programmatically custom event listener code
//   //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//   //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//   //// you might need to turn this on.
//   // autobindAllEvents: false,

//   //// If you want to manually install components, e.g.
//   //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//   //// Vue.component('GmapMarker', GmapMarker)
//   //// then disable the following:
//   // installComponents: true,
// })
// VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

Vue.component("vue-headful", vueHeadful);

//Shared components
Vue.component("financial-component-table", FinancialComponentTable);
Vue.component("quotation-invoice-table", QuotationInvoiceTable);
Vue.component("quotation-overview", QuotationOverview);
Vue.component("file-drop-zone", FileDropZone);
Vue.component("quotation-file-upload", QuotationFileUpload);
Vue.component("contact-layout", ContactLayout);
Vue.component("contact-info-layout", ContactInfoLayout);
Vue.component("shipment-worflow-view", ShipmentWorkflowView);
Vue.component("shipment-files-count", ShipmentFilesCount);
Vue.component("pt-rates-cell", PtRatesCell);
Vue.component("pt-rates-cell-price", PtRatesCellPrice);
Vue.component("pt-rates-cell-cost", PtRatesCellCost);
Vue.component("pt-rates-cell-air-price", PtRatesCellAirPrice);
Vue.component("pt-rates-cell-air-cost", PtRatesCellAirCost);
Vue.component("activity-log", ActivityLog);
Vue.component("file-cabinet-zone", FilesCabinetZone);
Vue.component("import-clearance-milestone", ImportClearanceMilestone);
Vue.component("export-clearance-milestone", ExportClearanceMilestone);
// Vue.component("gmap-view", GMapView)

// Admin components
Vue.component("dialog-company-rates", DialogCompanyRates);
Vue.component("dialog-customer-rank", DialogCustomerRank);
Vue.component("dialog-customer-list", DialogCustomerList);
Vue.component("dialog-manage-quotation", DialogManageQuotation);
Vue.component("dialog-manage-invoice", DialogManageInvoice);
Vue.component("dialog-email-widget", DialogEmailWidget);
Vue.component("dialog-tonnage-selection", DialogTonnageSelection); 
Vue.component("dialog-transport-tonnages", DialogTransportTonnages);
Vue.component("dialog-copy-monthly-rates", DialogCopyMonthlyRates);

// Customer components
Vue.component("dialog-new-quotation", DialogNewQuotation);
Vue.component("dialog-quotation-overview", DialogQuotationOverview);
Vue.component("dialog-schedule-list", DialogScheduleList);
Vue.component("dialog-shipment-information", DialogshipmentInformation);
Vue.component("dialog-file-cabinet", DialogFileCabinet);
Vue.component("dialog-notify-pull-back-ready", DialogNotifyPullBack);
Vue.component("dialog-message-box", DialogMessageBox);
Vue.component("dialog-message-notifier", DialogMessageNotifier);

Vue.component("dialog-company", DialogCompany);
Vue.component("dialog-user-account", DialogUserAccount);
Vue.component("dialog-company-contact-list", DialogCompanyContactList);
Vue.component("dialog-file-list", DialogFileList);

// initialise the global configuration for axios and set the base URL for Auth and API
const auth_axios = axios.create({
  baseURL: constant.AUTH_HOST
});

// set the base URL for backend API
const api_axios = axios.create({
  baseURL: constant.API_HOST
});

// set the withCredential to true
auth_axios.defaults.withCredentials = true;
// set the withCredential to true
api_axios.defaults.withCredentials = true;

// instance for Auth
Vue.prototype.$auth = auth_axios;
// instance for Backend API
Vue.prototype.$https = api_axios;

new Vue({
  render: h => h(App),
  store,
  router,
  vuetify,

  data() {
    return {
      allow_access: false,
      approved: false,
      company_id: null,
      uid: null,
      useraccount: {},
      role: null,
      email: null,
      access_token: "",
      username: null,

      messageCenterApp: messageCenterAppInstance,

      unread_count: 0,
      admin_board_unread_count: 0,

      notifications: [],
      notifications_limit: 20,

      fs_notification_listener: null,
      fs_admin_board_listener: null,

      fs_user_listener: null,


      showNavBar: true,
      showToolBar: true,
      fullScreenView: false,

      blockUIshow: false,
      blockUImsg: null,

      is_xero_connected: false,
      xeroAccessToken: null,
      xeroRefreshToken: null,
    }
  },

  created() {
    // initialise user
    this.init();
  },

  methods: {
    /**
     * Check if cookies for COOKIES_LOGIN_KEY is available
     * @return {boolean}
     */
    isCookies() {
      if (this.$cookies.isKey(constant.COOKIES_LOGIN_KEY)) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * Check if cookies for xero cookies is available
     * @return {boolean}
     */
    isXeroCookies(key) {
      if (this.$cookies.isKey(key)) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Get the available cookies object
     * @return {object} parsed token
     */
    getCookies() {
      var token = null;
      if (this.isCookies()) {
        token = this.$cookies.get(constant.COOKIES_LOGIN_KEY);
        /**
         *  token:
         *        - status: OK | FAIL | ERROR
         *        - msg: string
         *        - data: object | null
         *        - access_token: string
         */
        // if status != OK
        if (token.status != "OK") {
          token = null;
        }
      }
      return token;
    },

    /**
     * Get the available xero cookies object
     * @return {object} parsed token
     */
    getXeroCookies(key) {
      var token = null;
      if (this.isXeroCookies(key)) {
        token = this.$cookies.get(key);
      }
      return token;
    },

    /**
     * Initialise the user with the received valid token
     */
    init() {
      try {
        var token = this.getCookies();
        if (token != null) {
          // if role is an admin, then allow_access by default
          if (token.data.role == constant.ACCOUNT_ADMIN) {
            this.allow_access = true;
          } else {
            // console.log(token)
            this.approved = token.data.approved;
            this.company_id = token.data.company_id;
            this.allow_access = token.data.allow_access;
          }
          this.uid = token.data.uid;
          this.useraccount = token.data;
          this.username = token.data.first_name + " " + token.data.last_name;
          this.role = token.data.role;
          this.email = token.data.email;
          // set the Bearer access_token
          this.access_token = `Bearer ${token.access_token}`;

          // set the auth header for the axios instances of AUTH HOST (Gordon)
          this.$auth.defaults.headers.common[
            "Authorization"
          ] = this.access_token;

          // set the auth header for the axios instances of API HOST (Barbara)
          this.$https.defaults.headers.common[
            "Authorization"
          ] = this.access_token;

          // if current route
          if (this.$route.name == "login") {
            this.$router.replace({
              name: "userdashboard"
            });
          }

          // xero cookies validations
          this.xero_access_token = this.getXeroCookies(constant.COOKIE_XERO_ACCESS_TOKEN_KEY);
          this.xero_refresh_token = this.getXeroCookies(constant.COOKIE_XERO_REFRESH_TOKEN_KEY);

          if (this.xero_access_token == null && this.xero_refresh_token == null) {
            this.is_xero_connected = false
          } else {
            this.is_xero_connected = true
          }

          // console.log("xero access token: ", this.xero_access_token, " || xero refresh token: ", this.xero_refresh_token, " || is xero connected: ", this.is_xero_connected);

        } else {
          console.log("Access Denied OR Cookies not Found");
          // if route is in an ignore path
          if (constant.IGNORE_PATHS.includes(this.$route.name)) {
            // ignore
            console.log("ignore because this is: ", this.$route.name);
          } else if (this.$route.name != "register") {
            console.log("logout");
            // user logout regarless
            this.logout();
          }
        }
      } catch (error) {
        console.log("error:-> , ", error);
        // user logout regarless
        this.logout();
      }
    },

    /**
     * Verify user access & session token
     */
    async verify_user_token() {
      var verify_url = "/token/verify";

      // if environment is localhost, use the vue store
      var winUrl = window.location.href;
      if (winUrl.match(/localhost/g)) {
        // get the cookies
        var token = this.getCookies();
        if (token != null) {
          // set the url
          verify_url = `${verify_url}?access_token=${encodeURIComponent(
            token.access_token
          )}`;
        } else {
          console.log("logout, token is empty");

          // logout
          this.logout();
          return;
        }
      }

      // verify user token from the Auth Server
      var response = await this.$auth.get(verify_url);
      if (response.data.status == "OK") {
        // user successfully veried
        if (this.getCookies() == null) {
          // user logout regardless
          this.logout();
        }
      } else {
        // console.log(response.data);
        // user logout regardless
        this.logout();
      }
    },

    /**
     * Authenticate user through Gordon
     * @param {object} token
     */
    authenticate_user(uid, action = "login") {
      var self = this;
      return new Promise((success, reject) => {
        // set the url for either login or token refresh
        var url = `/user/login?uid=${uid}`;
        if (action == "token_refresh") {
          url = `/user/token_refresh?uid=${uid}`;
        }

        // Make a request for a user with a given ID
        self.$auth
          .get(url)
          .then(resp => {
            var response = resp.data;
            if (response.status == "OK") {
              // if environment is localhost, use the vue store
              var url = window.location.href;
              if (url.match(/localhost/g)) {
                // set the cookies for localhost
                self.$cookies.set(
                  constant.COOKIES_LOGIN_KEY,
                  response,
                  60 * 60 * 24 * 3,
                  null,
                  "localhost"
                );
              } else {
                // production
                self.$cookies.set(
                  constant.COOKIES_LOGIN_KEY,
                  response,
                  60 * 60 * 24 * 14,
                  null,
                  "accelefreight.com"
                );
              }
              // set user cred
              self.$store.state.user.uid = response.data.uid;
              self.$store.state.user.firstName = response.data.first_name;
              self.$store.state.user.lastName = response.data.last_name;
              self.$store.state.user.email = response.data.email;
              self.$store.state.user.role = response.data.role;

              // return success response
              success(response);
            } else {
              console.log("Server Error:-> ", response);
              // return reject response
              reject(response);
            }
          })
          .catch(err => {
            console.log("error:->", err);
            var res = {
              status: "ERROR",
              data: null,
              msg: err
            };
            // return reject response
            reject(res);
          });
      });
    },

    async exchange_code_for_xero_access_token(postform) {

      await this.$https.post("/xero_api/access_token/exchange_code", postform)
      .then((resp) => {
        var response = resp.data
        // console.log("response: ", response);

        if(response.status == "OK") {
          // Token expiry times: - id_token: 5 minutes - access_token: 30 minutes - refresh_token: 60 days
          this.xero_access_token = response.data.access_token
          this.xero_refresh_token = response.data.refresh_token

          if (this.xero_access_token === null || this.xero_access_token === undefined || this.xero_refresh_token === null || this.xero_refresh_token === undefined) {
            console.error("access token: ", this.xero_access_token, " || ", "refresh token: ", this.xero_refresh_token);
            throw "Invalid xero access token"
          }

            // store the xero access token for 25 mins (originally xero access token will expire after 30 mins)
            this.store_token_in_cookie(
              constant.COOKIE_XERO_ACCESS_TOKEN_KEY,
              response.data.access_token,
              "25min"
            )

            // store the xero refresh token for 55 days (originally xero refresh token will expire after 60 days)
            this.store_token_in_cookie(
              constant.COOKIE_XERO_REFRESH_TOKEN_KEY,
              response.data.refresh_token,
              "55d"
            )

            this.is_xero_connected = true
        } else {
          throw response.data.msg
        }
        })
        .catch((err) => {
          if (err.response) {
            console.error(err.response)
          }
          throw err;
        })
    },

    async xero_refresh_access_token() {
      let postform = {
        refresh_token: this.getXeroCookies(constant.COOKIE_XERO_REFRESH_TOKEN_KEY)
      }

      console.log("postform: ", postform);

      await this.$https.post("/xero_api/access_token/refresh", postform)
      .then((resp) => {
        var response = resp.data
        // console.log("response: ", response);

        // Token expiry times: - access_token: 30 minutes
        this.xero_access_token = response.data.access_token
        this.xero_refresh_token = response.data.refresh_token

         // store the xero access token for 25 mins (originally xero access token will expire after 30 mins)
          this.store_token_in_cookie(
            constant.COOKIE_XERO_ACCESS_TOKEN_KEY,
            response.data.access_token,
            "25min"
          )

          // store the xero refresh token for 55 days (originally xero refresh token will expire after 60 days)
          this.store_token_in_cookie(
            constant.COOKIE_XERO_REFRESH_TOKEN_KEY,
            response.data.refresh_token,
            "55d"
          )

          this.is_xero_connected = true
        })
        .catch((err) => {
          if (err.response) {
            console.error(err.response)
          }
          throw err;
        })
    },


    store_token_in_cookie(key, data, expiry) {
      // if environment is localhost, use the vue store
      var url = window.location.href
      if (url.match(/localhost/g)) {
        // set the cookies for localhost
        this.$cookies.set(key, data, expiry, null, "localhost")
      } else {
        // production
        this.$cookies.set(key, data, expiry, null, "accelefreight.com")
      }
    },

    /**
     * Re-Initialise the User Token
     * @param {string} uid
     * If uid is provided then, user was updated
     */
    re_init_user(uid) {
      return new Promise((success, reject) => {
        if (uid == null) {
          // get token from the cookies
          var token = this.getCookies();

          if (token != null) {
            // check if the company_id is availabe or empty
            if (
              token.data.hasOwnProperty("company_id") &&
              token.data.company_id == null
            ) {
              var self = this;
              // re-authenticate user
              this.authenticate_user(token.data.uid, "token_refresh").then(
                res => {
                  self.init();
                }
              )
            }
          }
        } else {
          // if uid is not null then re-authenticate the user
          // re-authenticate user
          this.authenticate_user(uid, "token_refresh").then(res => {
            this.init();
          });
        }

        // wait for 500ms before sending success response
        setTimeout(() => {
          success();
        }, 500);
      });
    },
    /**
     * User Logout
     */
    logout() {
      var self = this;
      return new Promise((success, reject) => {
        // if current route is not in the login or register page
        if (self.$route.name != "login" && self.$route.name != "register") {
          // logout user by deleting the cookies
          self.$auth
            .get("/user/logout")
            .then(res => { })
            .catch(err => { })
            .finally(() => {
              // console.log("logout status-->", response.data);
              self.$cookies.remove(constant.COOKIES_LOGIN_KEY);
              // firebase signout
              firebase.auth().signOut();
              self.$store.commit("user/logout");
              self.$router.replace({
                name: "login"
              });

              // detach firstore listener
              self.detach_firestore_listener();
              success();
            });
        } else {
          // console.log("route in login or register? ", self.$route.name);
          success();
        }
      })
    },

    /**
     * Fetch Notifications for this user
     */
    fetch_notifications(limit = 20) {
      var db = this.messageCenterApp.firestore();
      var self = this;

      // Get the notifications unread count for a user and listen to the document
      this.fs_user_listener = db
        .collection("users")
        .doc(self.uid)
        .onSnapshot(doc => {
          if (!doc.exists) {
            self.unread_count = 0;
            self.admin_board_unread_count = 0;
            console.error("doc doesnt exist");
          } else {
            // get the unread count number
            self.unread_count = doc.data().unread;

            // get the admin board unread count number
            self.admin_board_unread_count = doc.data().admin_board_unread;

            // if unread count is more than 20 then show 20+
            if (self.unread_count != null) {
              if (self.unread_count > 20) {
                self.unread_count = "20+";
              }
            }

            // if admin board unread count is more than 20 then show 20+
            if (self.admin_board_unread_count != null) {
              if (self.admin_board_unread_count > 20) {
                self.admin_board_unread_count = "20+";
              }
            }
          }
        });

      // query the collection Group (notifications) and listen
      // order by createdOn and fetch by multiple of 20 records
      this.fs_notification_listener = db
        .collectionGroup("notifications")
        .where("owner", "==", self.uid)
        .orderBy("createdOn", "desc")
        .limit(limit)
        .onSnapshot(querySnapshot => {
          // initialise notifications array
          self.notifications = [];
          querySnapshot.forEach(doc => {
            self.notifications.push({
              nid: doc.id,
              data: doc.data()
            });
          });
        });
      
    },

    /**
     * Make notification message as read
     */
    user_seen_notification(nid) {
      var db = this.messageCenterApp.firestore()
      var self = this
      // update the read value to true
      db.collection("users")
        .doc(self.uid)
        .collection("notifications")
        .doc(nid)
        .update({
          read: true
        })

      // decrement the unread count by 1
      db.collection("users")
        .doc(self.uid)
        .update({
          unread: firebase.firestore.FieldValue.increment(-1)
        })
    },

    /**
     * Mark all as read
     */
    mark_all_as_read() {
      var db = this.messageCenterApp.firestore()
      var self = this

      // Collection group query for notifications
      db.collectionGroup("notifications")
        .where("owner", "==", self.uid)
        .where("read", "==", false)
        .limit(500)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // update unread notification to read
            db.collection("users")
              .doc(self.uid)
              .collection("notifications")
              .doc(doc.id)
              .update({
                read: true
              })
          })
        })
        .catch(error => {
          console.error("error fetching unread notifications: ", error)
        })

      // update the unread value to 0
      db.collection("users")
        .doc(self.uid)
        .update({
          unread: 0
        })
    },

    /**
     * Detach firestore realtime listener
     */
    detach_firestore_listener() {
      if (this.is_admin) {
        this.fs_notification_listener();
        this.fs_admin_board_listener();
        this.fs_user_listener();
        console.log("firestore listener detached");
      }
    },

    /**
     * Get the dg class code icon
     * @param {string} item
     */
    get_dgc_icon(dg_class_code) {
      var color = "brown";
      var title = "";
      var icon = "fa-box";

      switch (dg_class_code) {
        case "DG-2":
          title = dg_class_code + ": Gases";
          color = "deep-orange lighten-1";
          icon = "fa-burn";
          break;
        case "DG-3":
          title = dg_class_code + ": Flammable liquids";
          color = "error";
          icon = "fa-fire";
          break;
        case "NON-DG":
          title = dg_class_code + ": Non dangerous goods";
          color = "brown lighten-1";
          break;
      }

      return {
        icon: icon,
        color: color,
        title: title
      };
    }
  },

  computed: {
    is_admin: {
      get() {
        return this.$store.state.user.role == constant.ACCOUNT_ADMIN;
      }
    },

    is_afu_admin: {
      get() {
        return this.role == constant.ACCOUNT_ADMIN;
      }
    },

    is_customer: {
      get() {
        return this.role == constant.ACCOUNT_CUSTOMER && this.company_id != null;
      }
    },

    is_super_admin: {
      get() {
        return constant.SUPER_ADMIN.includes(this.email);
      }
    },

    is_valid_company: {
      get() {
        return this.is_afu_admin || this.is_customer;
      }
    },

    is_company_approved: {
      get() {
        return this.is_afu_admin || (this.is_customer && this.approved);
      }
    },

    is_allow_access: {
      get() {
        return (
          this.is_afu_admin ||
          (this.is_company_approved &&
            this.allow_access)
        );

      }
    },

    xero_access_token: {
      set(value) {
        this.xeroAccessToken = value
      },

      get() {
        return this.xeroAccessToken
      }
    },

    xero_refresh_token: {
      set(value) {
        this.xeroRefreshToken = value
      },

      get() {
        return this.xeroRefreshToken
      }
    },

    has_xero_access_token: {
      get() {
        if (this.$cookies.isKey(constant.COOKIE_XERO_ACCESS_TOKEN_KEY)) {
        return true;
      } else {
        return false;
      }
      }
    },
    
    has_xero_refresh_token: {
      get() {
        if (this.$cookies.isKey(constant.COOKIE_XERO_REFRESH_TOKEN_KEY)) {
        return true;
      } else {
        return false;
      }
      }
    }
  }
}).$mount("#app");